// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/notepad-text.js';

import { paths } from '../generated/notepad-text';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('notepad-text', Original, paths);
